import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {QRCodeSVG} from "qrcode.react";
import "./generate.css";

export function Generate() {
    const location = useLocation();
    const [downloadUrl, setDownloadUrl] = useState("");
    const [textResult, setTextResult] = useState("");
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [copied, setCopied] = useState(false);

    // Check authentication status
    useEffect(() => {
        const currentUser = localStorage.getItem("userName");
        setIsAuthenticated(!!currentUser);
    }, []);

    useEffect(() => {
        const filenameHash = localStorage.getItem("fileNameHash");
        const text = localStorage.getItem("textinput");
        const host = window.location.hostname;
        const protocol = window.location.protocol;

        if (filenameHash) {
            setDownloadUrl(`${protocol}//${host}/api/download/${filenameHash}`);
        }

        setTextResult(text != null && text.trim() !== "" ? "This is your text:\n\n" + text : "There is no text");
    }, [location]);

    const handleDownload = () => {
        const currentUser = localStorage.getItem("userName");
        if (!currentUser) {
            alert("Please log in to download files");
            return;
        }

        fetch(`/api/download/${localStorage.getItem("fileNameHash")}`)
            .then(response => {
                if (response.status === 401) { alert("Please log in to download files"); return; }
                if (!response.ok) throw new Error('Network response was not ok');
                return response.blob();
            })
            .then(blob => {
                if (!blob) return;
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = localStorage.getItem("localfilename");
                link.click();
                URL.revokeObjectURL(url);
            })
            .catch(error => console.error('Error:', error));
    };

    const handleCopy = () => {
        if (!downloadUrl) return;
        navigator.clipboard.writeText(downloadUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const shareUrl = encodeURIComponent(downloadUrl);
    const shareText = encodeURIComponent("Check out this file I shared via Lightning.io");

    if (!isAuthenticated) {
        return (
            <main className="generate-main">
                <div className="generate-content">
                    <h1 className="generate-title">[ERR] access denied</h1>
                    <p style={{color: 'var(--fg-dim)', textAlign: 'center', letterSpacing: '0.05em', fontSize: 'var(--font-size-sm)'}}>
                        authenticate to access the file generator.
                    </p>
                </div>
            </main>
        );
    }

    return (
        <main className="generate-main">
            <div className="generate-content">
                <h1 className="generate-title">// transfer complete</h1>

                <div className="generate-sections">
                    <div className="qr-section">
                        <h2 className="section-title">
                            <span className="section-icon">[qr]</span>
                            QR CODE
                        </h2>
                        <div className="qr-container">
                            {downloadUrl && (
                                <QRCodeSVG value={downloadUrl} size={200} className="qr-image" />
                            )}
                            <p className="qr-description">&gt; scan to download on another device</p>
                        </div>
                    </div>

                    <div className="text-section">
                        <h2 className="section-title">
                            <span className="section-icon">[txt]</span>
                            TEXT OUTPUT
                        </h2>
                        <div className="text-container">
                            <div className="text-content" id="text-result">
                                {textResult}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Download link + copy */}
                <div className="link-section">
                    <h2 className="section-title">
                        <span className="section-icon">[url]</span>
                        DOWNLOAD LINK
                    </h2>
                    <div className="link-row">
                        <span className="link-text">{downloadUrl || '—'}</span>
                        <button className="copy-btn" onClick={handleCopy} title="Copy link">
                            {copied ? '[✓ copied]' : '[copy]'}
                        </button>
                    </div>
                </div>

                {/* Share section */}
                <div className="share-section">
                    <h2 className="section-title">
                        <span className="section-icon">[share]</span>
                        SHARE
                    </h2>
                    <div className="share-buttons">
                        <a
                            className="share-btn share-twitter"
                            href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareText}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            [ X / TWITTER ]
                        </a>
                        <a
                            className="share-btn share-facebook"
                            href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            [ FACEBOOK ]
                        </a>
                        <button
                            className="share-btn share-instagram"
                            onClick={handleCopy}
                            title="Copy link to share on Instagram"
                        >
                            {copied ? '[ ✓ LINK COPIED ]' : '[ INSTAGRAM (copy link) ]'}
                        </button>
                    </div>
                </div>

                <div className="download-section">
                    <button className="download-button" onClick={handleDownload}>
                        <span className="download-icon">[dl]</span>
                        [ DOWNLOAD FILE ]
                    </button>
                    <p className="download-hint">// link expires after 90 days</p>
                </div>
            </div>
        </main>
    );
}
